export default {
    name: 'toggle',
    _toggles: null,
    _targets: null,
    _groups : null,
    init() {
        this._toggles = document.querySelectorAll('[data-toggle]');
        this._targets = document.querySelectorAll('[data-toggle-target]');
        
        if (!this._toggles || !this._targets) {
            return;
        }

        this._groups  = document.querySelectorAll('[data-toggle-group]');
        
        for (const toggle of this._toggles) {
            const id = toggle.getAttribute('data-toggle');
            toggle.addEventListener('click', () => {
                if (toggle.getAttribute('data-toggle-class')) {
                    toggle.classList.toggle(toggle.getAttribute('data-toggle-class'));
                } else {
                    toggle.classList.toggle(toggle.classList[0] + '--active');
                }
                for (const target of this._targets) {
                    if (target.getAttribute('data-toggle-target') === id) {
                        if (target.getAttribute('data-toggle-class')) {
                            target.classList.toggle(target.getAttribute('data-toggle-class'));
                        } else {
                            target.classList.toggle(target.classList[0] + '--active');
                        }
                    }
                }

                const groupId = toggle.getAttribute('data-toggle-group');
                if (groupId && this._groups) {
                    for (const group of this._groups) {
                        if (group.getAttribute('data-toggle-group') === groupId && group !== toggle) {
                            group.classList.remove(group.classList[0] + '--active');
                            const groupTargetId = group.getAttribute('data-toggle');
                            for (const target of this._targets) {
                                if (target.getAttribute('data-toggle-target') === groupTargetId) {
                                    target.classList.remove(target.classList[0] + '--active');
                                }
                            }
                        }
                    }
                }
            });
        }
    }
}